// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1YgO8","vLegacy":"SelectSecondary_vLegacy__B7ORz","error":"SelectSecondary_error__3nkm1","disabled":"SelectSecondary_disabled__1VfS7"};